import AbstractRequestTask from '../AbstractRequestTask';

class GetUserTask extends AbstractRequestTask {

  constructor(userId) {
    super();
    this.userId = userId;
  }

  getUrl() {
    return `/api/social/user/${this.userId}`;
  }

  getParams() {
    let params =  {};
    this.params = Object.assign(params, this.params);
    return params;
  }

  success(data, b) {
    let isValid = (data.status && data.data);
    if (!isValid) {
      return this.reject(data, b);
    }
    this.resolve(data);
  }
}

export default GetUserTask;